// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "5e4dd43ea4e5a4a03992" + ".chunk.js";
};